import { FadeUp } from "@/components/Reveal";

const LegalLayout = ({ title, children, testid }) => (
  <main data-testid={testid} className="bg-ivoire pt-[72px] min-h-screen">
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 lg:py-24">
      <FadeUp>
        <h1 className="font-display font-medium text-petrol text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-12">
          {title}
        </h1>
      </FadeUp>
      <div className="space-y-10 text-sm sm:text-base text-mute leading-relaxed [&_h2]:font-display [&_h2]:text-petrol [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:mb-3 [&_strong]:text-encre">
        {children}
      </div>
    </div>
  </main>
);

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" testid="mentions-legales-page">
      <section>
        <h2>Éditeur du site</h2>
        <p>
          <strong>EQUORIS SAS</strong>
          <br />
          Siège social : 2 rue de la Levée – 49400 Saumur
          <br />
          SIREN : 101 316 719 — SIRET : 101 316 719 00018
          <br />
          RCS Angers
          <br />
          Email : contact@equoris.fr
        </p>
      </section>
      <section>
        <h2>Directeur de la publication</h2>
        <p>EQUORIS SAS.</p>
      </section>
      <section>
        <h2>Hébergement</h2>
        <p>
          Le site est hébergé par Cloudflare, Inc., 101 Townsend Street, San Francisco,
          CA 94107, États-Unis.
        </p>
      </section>
      <section>
        <h2>Activité</h2>
        <p>
          Négoce, achat et vente de matériaux et produits destinés à la construction et à la
          rénovation, à destination des professionnels du bâtiment. Le site equoris.fr est une
          vitrine commerciale : il ne propose ni vente en ligne, ni tarifs, ni disponibilités
          de stock. Toute demande fait l'objet d'une étude et d'une réponse commerciale
          personnalisée.
        </p>
      </section>
      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des contenus du site (textes, identité visuelle, logotype, éléments
          graphiques) est la propriété exclusive d'EQUORIS SAS. Toute reproduction ou
          représentation, totale ou partielle, sans autorisation écrite préalable est
          interdite.
        </p>
      </section>
      <section>
        <h2>Données personnelles</h2>
        <p>
          Pour toute information relative au traitement de vos données personnelles, consultez
          notre politique de confidentialité.
        </p>
      </section>
    </LegalLayout>
  );
}
